import { withAugmentationPanelLegacyForm } from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import {
  AugmentationToolbarChildOption,
  AugmentationToolbarOptionNode
} from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import { RouteComponentProps } from "react-router-dom"
import { selectResource } from "../../resource/components/manage/utils"
import ManageLicensePricingForm from "./pricing/ManageLicensePricingForm"
import { ManageLicenseSubscriptionConnected } from "./subscription/ManageLicenseSubscriptionCard"
import { loadResourceLicenseOffering } from "./utils"

// The panel primes the legacy store from the route the same way the Card routes
// do. Stated per destination rather than once on the parent: the panel only runs
// middleware for options that render something, and this parent doesn't.
const middleware: AugmentationToolbarChildOption["middleware"] = (
  route: RouteComponentProps<any>
) => {
  selectResource(route)
  loadResourceLicenseOffering(route)
}

// These forms are also the license offering Cards, so they're dressed for the
// panel here — at the node only the panel reads — rather than in the components.
export const licenseOfferingManageToolbar: AugmentationToolbarOptionNode = {
  key: "license-offering-manage",
  path: "manage/resource/:resourceId/cohorts/license/:resourceLicenseOfferingId(\\d+)?",
  label: "Manage",
  // A grouping, not a destination. Its form — the member-created cohorts toggle
  // over a description — is the Card route's way in to everything below it, and
  // the panel doesn't need it: the offer's own Title and Highlights say the same
  // thing, and the panel links straight to Pricing from the offer's Access &
  // Pricing section. So it contributes its path and nothing else, and the trail
  // reads past it.
  // These forms were laid out for a Card, so they ask the panel for Card room.
  panelWidth: "wide",
  children: [
    {
      key: "pricing",
      label: "Pricing",
      middleware,
      AugmentationComponent:
        withAugmentationPanelLegacyForm(ManageLicensePricingForm)
    },
    {
      key: "subscription",
      label: "Subscription",
      middleware,
      AugmentationComponent: withAugmentationPanelLegacyForm(
        ManageLicenseSubscriptionConnected
      )
    }
  ]
}
